export class Themes {
  //todo: TRANS: use localized themenames

  public availableThemes: string[] = ['dark-theme', 'light-theme'];
  private currentThemeIdx = -1;
  private defaultThemeIdx = 0;

  /**
   * gets the number of the currently selected theme
   */
  public getSelectedTheme() {
    return this.currentThemeIdx;
  }

  /**
   * selects the new theme and applies it
   * @param index theme number
   */
  public setSelectedTheme(index: number) {
    this.changeTheme(index);
  }

  /**
   * selects the new theme and applies it
   * @param name theme name
   */
  public setThemeByName(name: string) {
    if (name == null || name == '') {
      return;
    }
    name = name.toLowerCase();
    const idx = this.availableThemes.indexOf(name);
    if (idx >= 0) {
      this.changeTheme(idx);
    }
  }

  /**
   * applies the previous selected theme
   */
  public applyTheme() {
    if (this.currentThemeIdx >= 0) {
      this.changeTheme(this.currentThemeIdx);
    } else {
      this.changeTheme(this.defaultThemeIdx);
    }
  }

  public changeTheme(index: number) {
    // get html body element
    const bodyElement = document.body;

    if (!bodyElement || this.currentThemeIdx == index || index < 0 || index > this.availableThemes.length - 1) {
      return;
    }
    if (this.currentThemeIdx >= 0) {
      // remove existing theme class (needed if theme is being changed)
      const activeTheme = this.availableThemes[this.currentThemeIdx];
      bodyElement.classList.remove(activeTheme);
    }
    // add new theme class
    const newTheme = this.availableThemes[index];
    bodyElement.classList.add(newTheme);
    this.currentThemeIdx = index;
  }
}
